import { memo } from 'react';

function RelatedPartyIcon() {
  return (
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.3335 33.8337H36.6668V30.5003C36.6668 27.7389 34.4283 25.5003 31.6668 25.5003C30.0742 25.5003 28.6554 26.245 27.7398 27.4051M28.3335 33.8337H11.6668M28.3335 33.8337V30.5003C28.3335 29.4066 28.1228 28.3621 27.7398 27.4051M11.6668 33.8337H3.3335V30.5003C3.3335 27.7389 5.57207 25.5003 8.3335 25.5003C9.92617 25.5003 11.3449 26.245 12.2606 27.4051M11.6668 33.8337V30.5003C11.6668 29.4066 11.8775 28.3621 12.2606 27.4051M12.2606 27.4051C13.4893 24.3354 16.4915 22.167 20.0002 22.167C23.5088 22.167 26.511 24.3354 27.7398 27.4051M25.0002 12.167C25.0002 14.9284 22.7616 17.167 20.0002 17.167C17.2387 17.167 15.0002 14.9284 15.0002 12.167C15.0002 9.40557 17.2387 7.16699 20.0002 7.16699C22.7616 7.16699 25.0002 9.40557 25.0002 12.167ZM35.0002 17.167C35.0002 19.0079 33.5078 20.5003 31.6668 20.5003C29.8259 20.5003 28.3335 19.0079 28.3335 17.167C28.3335 15.326 29.8259 13.8337 31.6668 13.8337C33.5078 13.8337 35.0002 15.326 35.0002 17.167ZM11.6668 17.167C11.6668 19.0079 10.1744 20.5003 8.3335 20.5003C6.49255 20.5003 5.00016 19.0079 5.00016 17.167C5.00016 15.326 6.49255 13.8337 8.3335 13.8337C10.1744 13.8337 11.6668 15.326 11.6668 17.167Z"
        stroke="#3137B2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(RelatedPartyIcon);
